"use client";

import { authUpdatePassword } from "@/entities";
import { useMutation } from "@tanstack/react-query";
import { useRouter, useSearchParams } from "next/navigation";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

export function UpdatePasswordPage() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const code = searchParams?.get("code");

  if (!code) {
    router.push("/auth/login");
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
  });

  const updatePasswordMutation = useMutation({
    mutationFn: authUpdatePassword,
    onSuccess: () => {
      router.push("/app/main");
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });

  const onSubmit = async (data: any) => {
    if (updatePasswordMutation.isPending) return;
    await updatePasswordMutation.mutateAsync({ ...data, code });
  };

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">비밀번호 재설정</div>
              <small>아래에 새로운 비밀번호를 입력하세요.</small>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                  name="password"
                  control={control}
                  rules={{
                    required: "비밀번호를 입력해주세요.",
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="mb-3">
                        <label className="mb-2">
                          비밀번호 <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          id="password"
                          title="비밀번호를 입력해주세요."
                          placeholder="비밀번호를 입력해주세요."
                          className="form-control fs-13px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        {errors.password && (
                          <span className="text-red errorText">
                            {errors.password.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <Controller
                  name="passwordConfirm"
                  control={control}
                  rules={{
                    required: "비밀번호 재입력을 입력해주세요.",
                    validate: (value) => {
                      return value !== watch("password")
                        ? "비밀번호와 비밀번호 재입력이 일치하지 않습니다."
                        : undefined;
                    },
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <>
                      <div className="mb-3">
                        <label className="mb-2" htmlFor="passwordConfirm">
                          비밀번호 재입력 <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          id="passwordConfirm"
                          title="비밀번호 재입력을 입력해주세요."
                          placeholder="비밀번호 재입력을 입력해주세요."
                          className="form-control fs-13px"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value || ""}
                        />
                        {errors.passwordConfirm && (
                          <span className="text-red errorText">
                            {errors.passwordConfirm.message as string}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                />

                <div className="login-buttons">
                  <button
                    type="submit"
                    className="btn h-45px btn-theme d-block w-100 btn-lg"
                    disabled={updatePasswordMutation.isPending}
                  >
                    비밀번호 재설정
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div id="footer" className="app-footer text-center">
            &copy; 2025 wezoncoop. All Right Reserved
          </div>
        </div>
      </div>
    </>
  );
}
